export default class ContractScanCtrl {
    constructor($scope, contractTemplates, $uibModalInstance, logger, scanService) {
        $scope.scanData = {
            contractTemplates,
            bizName: contractTemplates[0] ? contractTemplates[0].bizName : '',
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }

        $scope.scan = function scan() {
            const opening = window.layer.msg('扫描中...', {
                time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
            })
            scanService.scan({
                scanType: '4',
                scanSource: '2',
                sourceIdentity: $scope.scanData.bizName, // 合同模板的业务名称
                imgType: '0',
                dataSource: '2',
            }).then(() => {}, (error) => {
                logger.logError(error)
            }).finally(() => {
                $uibModalInstance.close()
                window.layer.close(opening)
            })
        }
    }
}

ContractScanCtrl.$inject = ['$scope', 'contractTemplates', '$uibModalInstance', 'logger', 'scanService']



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/ContractScanCtrl.js